exports = module.exports = require("../../_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ele-upload-image,.ele-upload-image .el-loading-spinner{line-height:1}.ele-upload-image .el-icon-plus{vertical-align:middle}.ele-upload-image .el-upload--picture-card{width:auto;height:auto;background:none;line-height:inherit}.vue-image-crop-upload.ele-upload-image--cropper{z-index:99}.ele-upload-image--cropper .vicp-drop-area{background-color:#fbfdff!important}.ele-upload-image--cropper .vicp-icon1-arrow{border-bottom-color:#909399!important}.ele-upload-image--cropper .vicp-icon1-body{background-color:#909399!important}.ele-upload-image--cropper .vicp-icon1-bottom{border-color:#909399!important}", ""]);

// exports
